/* Feen Outfitters — coming-soon page (Shopify port)
   Vanilla JS: header contrast switch + scroll reveals only.
   The waitlist form is a real Shopify customer form (server-rendered
   success/error state), so no JS submit handler is needed. */
(function () {
  document.documentElement.classList.add('js');

  var header = document.querySelector('.feen-header');
  var heroEl = document.querySelector('.feen-hero');
  if (header && heroEl && 'IntersectionObserver' in window) {
    var headerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        header.classList.toggle('feen-header--solid', entry.intersectionRatio < 0.18);
      });
    }, { threshold: [0, 0.18, 1] });
    headerObserver.observe(heroEl);
  }

  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // If the waitlist form just posted successfully, scroll it into view
  // so the confirmation message is visible.
  var success = document.getElementById('feen-form-success');
  if (success) {
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    success.focus && success.focus();
  }
})();
